module.exports = __webpack_public_path__ + "img/de.293696c0.svg";